import React from 'react'
import { chain } from 'lodash'
import PropTypes from "prop-types"

import {
  Panel, Form, FormGroup, FormControl, ControlLabel, InputGroup, Modal
} from 'react-bootstrap'

import Button from '../../components/Button.jsx'
import MarkdownField from '../../lib/MarkdownField.jsx'
import FilesSelector from '../../lib/FilesSelector.jsx'
import { getText } from '../../lib/text.js'
import TranslateLink from '../../components/TranslateLink'

const styles = {
  fg: { display: "block", padding: 2 },
  label: { width: 200 },
  sublabel: { color: "#555", marginBottom: 2, fontSize: 14, fontStyle: "italic" },
}

class Dish extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { open: false }
  }

  render() {
    const { dish, onChange, onRemove, categories }  = this.props
    return (
      <Panel style={{ position: 'relative', padding: 0, margin: -3, marginBottom: 3 }}>
        <Panel.Body>

          <div style={{ display: 'inline', width: '100%' }}>
            {
              dish.background && dish.background.image
                ? (
                  <img src={dish.background.image} style={{ height: 40 }} />
                )
                : (
                  <span style={{ fontSize: 24 }}>🍽️ {' '}</span>
                )
            }
            <span style={{ marginLeft: 10 }}>
              {dish.name || getText("Sin nombre")}
            </span>

            {
              categories && dish.category && categories[dish.category] && (
                <span style={{ marginLeft: 10 }}>({categories[dish.category].name})</span>
              )
            }

            <Button
              onClick={() => this.setState({ open: true })}
              style={{ position: 'absolute', right : 10 }}
              glyph="pencil"
            />
          </div>


          {
            (this.state.open) && (
              <Modal show onHide={() => this.setState({ open: false })}>
                <Modal.Header>
                  <Modal.Title>Plato: {' '} {dish.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form inline>
                    {
                      categories && (
                        <FormGroup style={styles.fg}>
                          <ControlLabel style={styles.label}>Categoría</ControlLabel>
                          <FormControl
                            componentClass="select"
                            value={dish.category || "NULL"}
                            onChange={evt => onChange({ category: evt.target.value })}
                          >
                            <option value="NULL">Sin categoría</option>
                            {
                              chain(categories).values().sortBy("order").value()
                                .map((cat, i) => (
                                  <option key={cat.id} value={cat.id}>
                                    {i + 1}
                                    {' '}
  -
                                    {' '}
                                    {cat.name || "sin nombre"}
                                    {' '}
                                    ({cat.chName})
                                  </option>
                                ))
                            }
                          </FormControl>
                        </FormGroup>
                      )
                    }

                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>🇪🇸 Nombre para nosotros: {' '}</ControlLabel>
                      <FormControl
                        className= "name-control"
                        type="text"
                        value={dish.name}
                        onChange={evt => onChange({ name: evt.target.value })}
                      />
                    </FormGroup>
                    <FormGroup style={styles.fg}>
                      <ControlLabel style={styles.label}>🇨🇳 Nombre para cliente: {' '}</ControlLabel>
                      <FormControl
                        className= "name-control"
                        type="text"
                        value={dish.chName}
                        onChange={evt => onChange({ chName: evt.target.value })}
                      />
                      <TranslateLink text={dish.chName} />
                    </FormGroup>

                    {
                      !this.props.withoutPrice && (
                        <FormGroup style={styles.fg}>
                          <ControlLabel style={styles.label}>{getText("Precio")}: {' '}</ControlLabel>
                          <InputGroup>
                            <FormControl
                              className= "price-control"
                              type="number"
                              value={dish.price}
                              onChange={evt => this.props.onChange({ price: evt.target.value })}
                            />
                            <InputGroup.Addon>€</InputGroup.Addon>
                          </InputGroup>
                        </FormGroup>
                      )
                    }

                    <FormGroup style={styles.fg}>
                      <MarkdownField
                        style={{ marginTop: 10 }}
                        onChange={description => onChange({ description })}
                        value={dish.description}
                        label={(
                          <span>
                            {getText("🇨🇳 Descripción plato (cortita)")}
                            <TranslateLink text={dish.description} />
                          </span>
                        )}
                      />
                    </FormGroup>
                    <FilesSelector
                      value={dish.background}
                      onChange={obj => onChange({ background: obj })}
                      includeNotes
                      fileNotes={dish.fileNotes}
                      onNotesChange={fileNotes => onChange({ fileNotes })}
                      labels={{
                        image: getText("Imagen")
                      }}
                      extensions={{ image: ["jpg", "jpeg", "png"] }}
                      title = {getText("Imagen plato")}
                    />
                    <Button
                      glyph="minus"
                      bsStyle="link"
                      onClick={() => onRemove()}
                    >
                      Eliminar plato
                    </Button>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => this.setState({ open: false })}>
                    Cerrar
                  </Button>
                </Modal.Footer>
              </Modal>
            )
          }
        </Panel.Body>
      </Panel>
    )
  }
}

Dish.propTypes = {
  dish: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  categories: PropTypes.object.isRequired,
  withoutPrice: PropTypes.bool,
}

export default Dish
